<script lang="ts">
    import { locale } from "../../locale.svelte.js";
    import { CalendarDate, formatLocalizedDate, parseDateString } from "@repo/utils";

    const { value = $bindable(), withTime = false }: { value: string | CalendarDate; withTime?: boolean } = $props();
    const date = $derived(typeof value === "string" ? parseDateString(value) : value.toDate("UTC"));
</script>

{#if date instanceof Error}
    <span title={value.toString()} class="text-error-foreground">Invalid date</span>
{/if}

<svelte:boundary>
    <span class="tabular-nums">{formatLocalizedDate(date, locale.current, { withTime })}</span>
    {#snippet failed(error: unknown)}
        <span title={String(error)} class="text-error-foreground">{value}</span>
    {/snippet}
</svelte:boundary>
